import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import ScrollToTop from "./components/ScrollToTop";
import { InquiryProvider } from "./context/InquiryContext";
import { ProductInquiryModal } from "./components/ProductInquiryModal";
import { FloatingInquiryBar } from "./components/FloatingInquiryBar";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <ProductInquiryModal />
      <FloatingInquiryBar />
    </div>
  );
};

function App() {
  return (
    <InquiryProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produkter" element={<Products />} />
            <Route path="/ydelser" element={<Services />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/priser" element={<Pricing />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
          </Routes>
        </Layout>
      </Router>
    </InquiryProvider>
  );
}

export default App;
